<template>
  <div class="row mb-3">
    <div class="col-12">
      <h3 class="mb-3">
        {{ $t('CUSTOMERS.TITLE.ALL_EMAILS') }}
      </h3>
    </div>
    <div class="col-12" v-if="customerStats">
      <HMAlertInfo status="success" v-if="customerStats.marketing_opt_in">
        {{ $t('CUSTOMERS.NOTIFICATIONS.THIS_CUSTOMER_HAS_SUBSCRIBED') }}
      </HMAlertInfo>
      <HMAlertInfo status="danger" v-else>
        {{ $t('CUSTOMERS.NOTIFICATIONS.THIS_CUSTOMER_IS_NOT_SUBSCRIBED') }}
      </HMAlertInfo>
      <HMPaginatedTable
        name="customer-emails-table"
        api="sale/getCustomerEmails"
        :fields="customerEmailsFields"
        :query="query"
        class="mt-4"
        ref="customer-emails-table"
        :pageInQuery="true"
        :perPageFixed="10"
        :disableHover="true"
      >
        <template slot="table-controls">
          <div
            class="d-flex flex-column flex-md-row justify-content-start align-items-center"
          >
            <div class="flex-grow-1 mr-3">
              <HMSearch v-model="search" />
            </div>
            <div
              class="d-flex flew-row justify-content-between align-items-center"
            >
              <HMCheckBox class="mx-2" v-model="opened">
                {{ $t('MARKETING.TABLE.OPENED') }}
              </HMCheckBox>
              <HMCheckBox class="mx-2" v-model="clicked">
                {{ $t('MARKETING.TABLE.CLICKED') }}
              </HMCheckBox>
            </div>
          </div>
        </template>
        <template slot="no-data">
          <HMAlertInfo status="danger">
            {{ $t('CUSTOMERS.NOTIFICATIONS.NO_EVENTS_TO_SHOW_YET') }}
            <template v-slot:options>
              <router-link
                :to="{
                  name: 'marketing-emails',
                }"
                class="undecorated-router-link"
              >
                {{ $t('CUSTOMERS.LINK.CREATE_AN_EMAIL') }}
              </router-link>
            </template>
          </HMAlertInfo>
        </template>
        <template v-slot:email="{ data }">
          <router-link
            :to="{
              name: 'marketing-email-detail',
              params: { id: data.studio_email.id },
            }"
            class="d-block"
          >
            {{ data.studio_email.subject }}
          </router-link>
        </template>
        <template v-slot:opened="{ data }">
          <HMCheck
            v-tooltip="{
              content: data.opened_at
                ? $formatDate(data.opened_at, 'date-time')
                : '',
              delay: 100,
              placement: 'top',
              container: 'body',
            }"
            v-model="data.opened"
          />
        </template>
        <template v-slot:clicked="{ data }">
          <HMCheck
            v-tooltip="{
              content: data.clicked_at
                ? $formatDate(data.clicked_at, 'date-time')
                : '',
              delay: 100,
              placement: 'top',
              container: 'body',
            }"
            v-model="data.clicked"
          />
        </template>
      </HMPaginatedTable>
    </div>
  </div>
</template>

<script>
import { errorToMessage } from '@/core/utils/errors';
import DirtyMixin from '../../../mixins/DirtyMixin';
import EmailPreviewModal from '../../../components/marketing/EmailPreviewModal';
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'CustomerDetailEmails',
  components: {},
  mixins: [DirtyMixin],
  computed: {
    ...mapGetters({
      customerStats: 'sale/customerStats',
    }),
    query() {
      const query = {
        customerId: this.$route.params.id,
        q: this.search,
      };
      if (this.opened) query.opened = true;
      if (this.clicked) query.clicked = true;
      return query;
    },
    customerEmailsFields() {
      return [
        {
          name: 'email',
          title: this.$t('MARKETING.TABLE.EMAIL'),
          cssClass: 'h5',
        },
        {
          name: 'opened',
          title: this.$t('MARKETING.TABLE.OPENED'),
        },
        {
          name: 'clicked',
          title: this.$t('MARKETING.TABLE.CLICKED'),
        },
      ];
    },
  },
  data() {
    return {
      search: '',
      opened: false,
      clicked: false,
      isPreviewing: false,
    };
  },
  methods: {
    async preview(emailId) {
      try {
        this.isPreviewing = true;
        const emailPreview = await this.$store.dispatch(
          'marketing/getEmailPreview',
          emailId
        );
        this.$modal.show(
          EmailPreviewModal,
          {
            content: emailPreview.preview,
          },
          {
            classes: ['vm--inline-modal'],
          }
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load email preview',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isPreviewing = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
